import { useState } from "react";
import { FaExclamationTriangle } from "react-icons/fa";

function ConfirmationMessage({ message, onConfirm, onCancel, loading = false, deleteInfo = [], nota = 'Confirmación', titleButtonConfirmation = 'Confirmar', titleButtonCancel = 'Cancelar' }) {
  const [showDetails] = useState(false);

  return (
    <div className="confirmation-message-main-div">
      <div className="confirmation-message-secondary-div">
        <div className="confirmation-message-body">
          <div className="confirmation-message-icon-wrap">
            <FaExclamationTriangle className="confirmation-message-icon" />
          </div>
          <h3 className="confirmation-message-title">{nota}</h3>
          <p className="confirmation-message-message">
            {message}
          </p>
          {showDetails && (
            <div className="confirmation-message-details">
              <span><strong>Usuarios afectados:</strong> {deleteInfo?.activeUsersCount}</span>
            </div>
          )}
          <div className="confirmation-message-actions">
            <button
              className="confirmation-message-button-cancel"
              onClick={onCancel}
              disabled={loading}
            >
              {loading ? "Procesando..." : titleButtonCancel}
            </button>
            <button
              className="confirmation-message-button-confirm"
              onClick={onConfirm}
              disabled={loading}
            >
              {loading ? "Procesando..." : titleButtonConfirmation}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConfirmationMessage;